import { Company } from '@/context/types';
import { Step } from '@/pages/subscription/types';
import { Outlet, UserResponse } from '@/types';
import { Tax } from '@/types/taxes.type';
import { createSlice } from '@reduxjs/toolkit';

type Marketing = {
  useType: string;
  businessType: string;
  monthlyRevenue: string;
};
export type StateValues = {
  step: Step;
  user: UserResponse | null;
  company: Company | null;
  outlet: Outlet | null;
  marketing: Marketing | null;
  tax: Tax | null;
  useCoupon: boolean;
};

const initialState: StateValues = {
  step: Step.Step1,
  user: null,
  company: null,
  outlet: null,
  marketing: null,
  tax: null,
  useCoupon: true,
};
export const boardingSlice = createSlice({
  name: 'boarding',
  initialState,
  reducers: {
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    updateUseCoupon: (state, action) => {
      state.useCoupon = action.payload;
    },
    updateCompany: (state, action) => {
      state.company = action.payload;
    },
    updateOutlet: (state, action) => {
      state.outlet = action.payload;
    },
    updateMarketing: (state, action) => {
      state.marketing = action.payload;
    },
    updateTax: (state, action) => {
      state.tax = action.payload;
    },
    nextStep: (state) => {
      state.step += 1;
    },
    prevStep: (state) => {
      state.step -= 1;
    },
    getToLastStep: (state) => {
      state.step = Step.Step4;
    },
  },
});

export const {
  updateUser,
  updateCompany,
  updateOutlet,
  nextStep,
  prevStep,
  updateMarketing,
  updateTax,
  getToLastStep,
  updateUseCoupon,
} = boardingSlice.actions;

export default boardingSlice.reducer;
